import { Routes, Route, Navigate } from 'react-router-dom';
import appInfo from './app-info';
import routes from './app-routes';
import { SideNavOuterToolbar as SideNavBarLayout } from './layouts';
import { Footer } from './components';
import { useAuth } from './contexts/auth';

export default function Content() {
  const { user } = useAuth()

  function checkClaims(authorization) {
    
    if (!user)
      return false

    if (authorization == null)
      return true

    const result = user.claims.filter(item => item.name === "TalentWavePermission" && item.value === authorization)
    
    return result.length > 0
  }

  return (

    <SideNavBarLayout title={appInfo.title}>
      <Routes>
        {
          routes.filter(item => checkClaims(item.authorization)).map(({ path, element, authorization }) => (
            <Route
              key={path}
              path={path}
              element={element}
              authorization={authorization}
            />
          ))
        }

        <Route
          path='*'
          element={<Navigate to='/employee-home' />}
        />
      </Routes>

      {/* <Footer>
        Copyright © 2011-{new Date().getFullYear()} {appInfo.title} Inc.
        <br />
        All trademarks or registered trademarks are property of their
        respective owners.
      </Footer> */}
    </SideNavBarLayout>
  );
}

